import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Bonuses } from './Bonuses';
import { Benefits } from './Benefits';
import { Offer } from './Offer';
import { Guarantee } from './Guarantee';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-ocean-teal-light selection:text-ocean-teal-dark" data-id="element-118">
      <main data-id="element-119">
        <Hero data-id="element-120" />
        <PainPoints data-id="element-121" />
        <Bonuses data-id="element-122" />
        <Benefits data-id="element-123" />
        <Offer data-id="element-124" />
        <Guarantee data-id="element-125" />
        <Testimonials data-id="element-126" />
        <FAQ data-id="element-127" />
        <FinalCTA data-id="element-128" />
      </main>
      <Footer data-id="element-129" />
      <StickyCTA data-id="element-130" />
    </div>;
}